module.exports = __webpack_public_path__ + "static/media/text-align-left.9957364b.svg";